import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumb from "../../../common/Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import Select from "../../../new_Dashboard/components/Select";
import { Button, Form, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { Container } from "reactstrap";
import DateTime from "react-datetime";
import DateFormatter from "dateformat";
import { toast } from "react-toastify";
import AddCommentModal from "../shared/add_note.model";
import {
	useAddActionNoteMutation,
	useAddSubscriptionMutation,
	useGetCountryListQuery,
	useGetDeviceTypeQuery,
	useGetModeOfPaymentQuery,
	useGetSubscriptionTypeQuery,
} from "../../../../store/api/userManagementApi";

const Forms = ({ history, location }) => {
	const storedUserData = useSelector((state) => state.userManagement.userData) || {};
	const resolvedUserId = location?.state?.user_id || storedUserData?.user_id || null;
	const resolvedEmail = location?.state?.user_email || storedUserData?.user_email || null;

	const [disableFormButton, setDisableFormButton] = useState(false);
	const [isDateInputInvalid, setIsDateInputInvalid] = useState(false);
	const [countryList, setCountryList] = useState([]);
	const [subType, setSubType] = useState([]);
	const [deviceType, setDeviceType] = useState([]);
	const [paymentMode, setPaymentMode] = useState([]);
	const [successflag, setSuccessflag] = useState(false);
	const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
	const [pendingSubmitData, setPendingSubmitData] = useState(null);
	const { data: countryResponse } = useGetCountryListQuery("");
	const { data: subscriptionResponse } = useGetSubscriptionTypeQuery();
	const { data: deviceResponse } = useGetDeviceTypeQuery();
	const { data: modeOfPaymentResponse = [] } = useGetModeOfPaymentQuery();
	const [addActionNoteMutation] = useAddActionNoteMutation();
	const [addSubscriptionMutation] = useAddSubscriptionMutation();

	const staticValidation = () => {
		let formValid = true;
		let errors = {};
		const dateParts = typeof values.date === "string" ? values.date.split("-") : [];
		const dateValue = new Date(`${values.date}T00:00:00`);
		const isValidDate =
			!isDateInputInvalid &&
			dateParts.length === 3 &&
			dateParts[0].length === 4 &&
			dateParts[1].length === 2 &&
			dateParts[2].length === 2 &&
			!Number.isNaN(dateValue.getTime()) &&
			dateValue.getFullYear() === Number(dateParts[0]) &&
			dateValue.getMonth() + 1 === Number(dateParts[1]) &&
			dateValue.getDate() === Number(dateParts[2]);

		if (!isValidDate) {
			errors = { ...errors, date: "Please enter a valid date" };
			formValid = false;
		}

		if (!values.country) {
			errors = { ...errors, country: "Please Select One country" };
			formValid = false;
		}
		if (!values.device) {
			errors = { ...errors, device: "Please Select One Device" };
			formValid = false;
		}
		if (!values.subscrioptionType) {
			errors = {
				...errors,
				subscrioptionType: "Please Select One SubscrioptionType",
			};
			formValid = false;
		}
		if (!values.receiptId) {
			errors = { ...errors, receiptId: "Please Enter Receipt Id" };
			formValid = false;
		}
		if (!values.modeofPayment) {
			errors = {
				...errors,
				modeofPayment: "Please Select One Mode of Payment",
			};
			formValid = false;
		}
		setErrors(errors);
		setDisableFormButton(!formValid);
		return formValid;
	};

	const [values, setValues] = useState({
		email: resolvedEmail,
		userId: resolvedUserId,
		country: null,
		date: addDay(new Date().toISOString().slice(0, 10), 0),
		transaction: { id: 1, label: "New" },
		subscrioptionType: null,
		modeofPayment: null,
		device: null,
		currencyName: null,
		currency: null,
		receiptId: null,
	});

	const [errors, setErrors] = useState({
		date: "",
		country: "",
		subscrioptionType: "",
		modeofPayment: "",
		receiptId: "",
		device: "",
	});

	useEffect(() => {
		const currencyDataFromLocalStorage = JSON.parse(localStorage.getItem("currency"));

		if (currencyDataFromLocalStorage) {
			setValues((prev) => ({
				...prev,
				currency: currencyDataFromLocalStorage.currency_id,
				currencyName: currencyDataFromLocalStorage.currency_name,
			}));
		}
	}, []);

	useEffect(() => {
		const countryData = Array.isArray(countryResponse?.data) ? countryResponse.data : [];
		const mappedCountries = countryData.map((element, index) => ({
			value: index + 1,
			label: element.country_name,
			code: element.code,
		}));
		setCountryList(mappedCountries);
	}, [countryResponse]);

	useEffect(() => {
		const subscriptionData = Array.isArray(subscriptionResponse?.data) ? subscriptionResponse.data : [];
		const mappedSubscriptions = subscriptionData.map((element, index) => ({
			value: index + 1,
			label: element.subscription_name,
			subscription_type_id: element.publisher_subscription_id,
			price: element.price,
		}));
		setSubType(mappedSubscriptions);
	}, [subscriptionResponse]);

	useEffect(() => {
		const appData = Array.isArray(deviceResponse?.data) ? deviceResponse.data : [];
		const mappedDeviceTypes = appData
			.filter((element) => element?.app_type_name && element?.subscription_device_type)
			.map((element, index) => ({
				value: index + 1,
				subscription_device_type: element.subscription_device_type,
				label: element.app_type_name,
			}));
		setDeviceType(mappedDeviceTypes);
	}, [deviceResponse]);

	useEffect(() => {
		setPaymentMode(Array.isArray(modeOfPaymentResponse) ? modeOfPaymentResponse : []);
	}, [modeOfPaymentResponse]);

	useEffect(() => {
		setDisableFormButton(false);
	}, [values]);

	function onChangeHandler(value, name) {
		setValues({
			...values,
			[name]: value,
		});
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		setErrors(errors);
		if (staticValidation()) {
			let inputFields = {
				receipt_id: values.receiptId,
				transaction_type: values.transaction.id,
				subscription_id: values.subscrioptionType.subscription_type_id,
				device_type: values.device?.subscription_device_type,
				user_id: values.userId,
				amount: values.subscrioptionType.price,
				country_code: values.country.code,
				mode_of_payment: values.modeofPayment.label,
				valid_from: values.date,
				currency: values.currency,
			};

			setPendingSubmitData(inputFields);
			setIsCommentModalOpen(true);
		}
	};

	function addDay(date, day) {
		var formattedDate = new Date(date);
		formattedDate.setDate(formattedDate.getDate() + +day);
		return formattedDate.toISOString().slice(0, 10);
	}

	const handleCommentSubmit = async (note) => {
		try {
			const commentData = {
				action_type: "subscription-add",
				note: note,
				user_id: values.userId,
			};

			await addActionNoteMutation(commentData).unwrap();

			setIsCommentModalOpen(false);
			if (pendingSubmitData) {
				proceedWithSubscription(pendingSubmitData);
			}
		} catch (error) {
			console.error("Comment submission error:", error);
			setIsCommentModalOpen(false);
			if (pendingSubmitData) {
				proceedWithSubscription(pendingSubmitData);
			}
		}
	};

	const proceedWithSubscription = (inputFields) => {
		addSubscriptionMutation(inputFields)
			.unwrap()
			.then((response) => {
				if (response?.success) {
					setSuccessflag(true);
					setDisableFormButton(true);
					setTimeout(() => {
						history.push("/operations/editUser/subscriptions", {
							values: { user_id: location?.state?.user_id },
						});
					}, 1000);
				} else {
					toast("Something went wrong");
				}
			})
			.catch(() => {
				toast("Something went wrong");
			});
		setPendingSubmitData(null);
	};

	return (
		<>
			<Form onSubmit={handleSubmit}>
				<div className="bread-crumbs-container col-lg-12 border-0 fit-max-width">
					<div className="bread-crumbs">
						<div className="heading pl-1 pt-2 ml-0">
							<Breadcrumb
								items={[
									{ label: "User Management" },
									{ label: "User List", to: "/operations/UserManagment" },
									{
										label: "User Details",
										to: {
											pathname: "/operations/editUser/subscriptions",
											state: { values: { user_id: resolvedUserId } },
										},
									},
								]}
							/>
							<h1>Add User Subscription Details</h1>
						</div>
						<div></div>
					</div>
				</div>
				<Container className="body-inner-wrapper mt-5 p-0 bg-200 border-0">
					<div className="create-body-wrapper col-md-12 col-xl-12">
						<div className="create-body-section col-md-12 col-xl-12 ml-0 p-0 border-0">
							<FormGroup className="mb-0" id="p-x-0">
								<Row noGutters className="edit-section">
									<Col lg={4} className="pr-lg-2" style={{ marginTop: "-7px" }}>
										<Label for="exampleName">
											Date <font color="red">*</font>
										</Label>

										<DateTime
											closeOnSelect={true}
											dateFormat="DD-MM-YYYY"
											timeFormat={false}
											name="date"
											defaultValue={DateFormatter(values?.date, "dd-mm-yyyy")}
											onChange={(dateValue) => {
												if (!dateValue || typeof dateValue.toISOString !== "function") {
													setIsDateInputInvalid(true);
													return;
												}

												const isoDate = dateValue.toISOString();
												if (!isoDate) {
													setIsDateInputInvalid(true);
													return;
												}

												setIsDateInputInvalid(false);
												setErrors((previousErrors) => ({ ...previousErrors, date: "" }));
												onChangeHandler(addDay(isoDate.slice(0, 10), 1), "date");
											}}
											classNamePrefix="react-select"
										/>
										<p style={{ color: "red", fontStyle: "Italic" }}>{errors?.date}</p>
									</Col>
									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											User Email <font color="red">*</font>
										</Label>

										<Input
											readOnly={true}
											value={values?.email}
											name="email"
											onChange={({ target }) => {
												onChangeHandler(target.value, "email");
											}}
											classNamePrefix="react-select"
										/>
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											User ID <font color="red">*</font>
										</Label>

										<Input
											readOnly={true}
											value={values?.userId}
											name="userId"
											onChange={({ target }) => {
												onChangeHandler(target.value, "userId");
											}}
											classNamePrefix="react-select"
										/>
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Transaction Type <font color="red">*</font>
										</Label>

										<Input value={values.transaction.label} classNamePrefix="react-select" readOnly={true} />
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Currency <font color="red">*</font>
										</Label>

										<Input
											readOnly={true}
											value={values?.currencyName}
											name="currency"
											onChange={({ target }) => {
												onChangeHandler(target.value, "userId");
											}}
											classNamePrefix="react-select"
										/>
									</Col>
									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Amount <font color="red">*</font>
										</Label>

										<Input readOnly={true} value={values?.subscrioptionType?.price} classNamePrefix="react-select" />
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Select Country <font color="red">*</font>
										</Label>

										<Select
											value={values.country && values.country}
											name="country"
											onChange={(value) => {
												onChangeHandler(value, "country");
											}}
											classNamePrefix="react-select"
											options={countryList}
										/>
										{
											<p style={{ color: "red", fontStyle: "Italic" }}>
												{" "}
												{errors?.country}
											</p>
										}
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Subscription Type <font color="red">*</font>
										</Label>

										<Select
											value={values?.subscrioptionType}
											name="subscrioptionType"
											onChange={(value) => {
												onChangeHandler(value, "subscrioptionType");
											}}
											classNamePrefix="react-select"
											options={subType}
										/>
										{
											<p style={{ color: "red", fontStyle: "Italic" }}>
												{" "}
												{errors?.subscrioptionType}
											</p>
										}
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Mode of Payment<font color="red">*</font>
										</Label>

										<Select
											value={values?.modeofPayment}
											name="modeofPayment"
											onChange={(value) => {
												onChangeHandler(value, "modeofPayment");
											}}
											classNamePrefix="react-select"
											options={paymentMode}
										/>
										{
											<p style={{ color: "red", fontStyle: "Italic" }}>
												{" "}
												{errors?.modeofPayment}
											</p>
										}
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Device <font color="red">*</font>
										</Label>

										<Select
											value={values?.device}
											name="device"
											onChange={(value) => {
												onChangeHandler(value, "device");
											}}
											classNamePrefix="react-select"
											options={deviceType}
										/>
										{
											<p style={{ color: "red", fontStyle: "Italic" }}>
												{" "}
												{errors?.device}
											</p>
										}
									</Col>

									<Col lg={4} className="pr-lg-2">
										<Label for="exampleName">
											Receipt ID <font color="red">*</font>
										</Label>

										<Input
											value={values?.receiptId}
											name="receiptId"
											onChange={({ target }) => {
												onChangeHandler(target.value, "receiptId");
											}}
											classNamePrefix="react-select"
										/>
										{
											<p style={{ color: "red", fontStyle: "Italic" }}>
												{" "}
												{errors?.receiptId}
											</p>
										}
									</Col>
								</Row>

								{successflag ? (
									<FormGroup>
										<div className="form-row" style={{ backgroundColor: "#9edbe2", marginTop: "20px" }}>
											<Row style={{ width: "100%" }}>
												<h4 style={{ marginLeft: "30px", marginTop: "10px" }} className="alert-heading">
													Success!
												</h4>
											</Row>
											<Row>
												<p style={{ marginLeft: "30px" }}>Your purchase has been successfully completed.</p>
											</Row>
										</div>
									</FormGroup>
								) : null}
							</FormGroup>
							<div className="df justify-content-center">
								<Button type="submit" color="primary" disabled={disableFormButton} style={{ width: "149px" }}>
									Apply Change
								</Button>
							</div>
						</div>
					</div>
				</Container>
			</Form>

			<AddCommentModal
				isOpen={isCommentModalOpen}
				toggle={() => setIsCommentModalOpen(false)}
				onSubmit={handleCommentSubmit}
				actionType="subscription-add"
			/>
		</>
	);
};

export default withRouter(Forms);
